import React, { PureComponent, Fragment } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';

import styles from './index.css';

class Modal extends PureComponent {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
        maskClosable: PropTypes.bool,
        onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    };

    ref = React.createRef();

    static defaultProps = {
        maskClosable: true,
    };

    state = {};

    handleClose = e => {
        e.stopPropagation();
        this.props.onClose();
    };

    handleClickMask = e => {
        e.stopPropagation();
        this.props.onClose();
    };

    static getDerivedStateFromProps = (newProps, state) => {
        if (newProps.isOpen) {
            document.body.classList.add(styles.toggle_body);
        } else {
            document.body.classList.remove(styles.toggle_body);
        }

        return {
            ...state,
        };
    };

    // componentDidMount = () => {
    //     const windowHeight = document.documentElement.clientHeight;
    //     const modal = this.ref.current;

    //     if (windowHeight < 820) {
    //         // console.log(this.ref.current);
    //         modal.style.top = '150px';
    //     } else {
    //         modal.style.top = '200px';
    //     }
    // };

    componentWillUnmount = () => {
        document.body.classList.remove(styles.toggle_body);
    };

    render() {
        const { isOpen, title, children, maskClosable } = this.props;

        return (
            isOpen && (
                <Fragment>
                    <div className={styles.modal_mask} onClick={maskClosable ? this.handleClickMask : () => {}} />
                    <div className={styles.modal} ref={this.ref}>
                        <div className={styles.content}>{children}</div>
                        <div className={styles.close} onClick={this.handleClose} />
                    </div>
                </Fragment>
            )
        );
    }
}

export { Modal };
export default errorBoundary(Modal);
